<div>
    <div class="card m-3">
        <h5 class="card-header" style="font-size: 21px">
            Exam Related Issue Status
        </h5>
        <div class="card-body">

            <mat-form-field>
                <input matInput (keyup)="applyFilter($event)" placeholder="Filter">
            </mat-form-field>


            <div class="example-container mat-elevation-z8">
                <mat-table #table [dataSource]="dataSource" matSort>

                    <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                    <!-- Position Column -->
                    <ng-container matColumnDef="refno">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Id </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.refno}} </mat-cell>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="username">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.username}} </mat-cell>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="regno">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Reg No </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.regno}} </mat-cell>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="iticode">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> ITI Code </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="ntef">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Nature of Technical Issue Faced
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.ntef}} </mat-cell>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="issuedetail">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Issue Detail </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.issuedetail}} </mat-cell>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="Status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
                        <mat-cell *matCellDef="let element"> <span [class]="element.admin_status">
                                {{element.admin_status}} </span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="view">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> View </mat-header-cell>
                        <mat-cell *matCellDef="let element"> <button class="btn btn-primary"
                                (click)="selected_view.select(element)" (click)="report_view()">
                                View </button>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                </mat-table>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>


            </div>


            <!-- <table>
                <tr>
                    <th>TicketId</th>
                    <th>Name</th>
                    <th>Reg No</th>
                    <th>ITI Code</th>
                    <th>Nature of Technical Issue Faced</th>
                    <th>Issue Detail</th>
                    <th>Stattus</th>

                </tr>
                <tr *ngFor="let item of eri_status_admin let i=index">
                    <td>{{item.refno}}</td>
                    <td>{{item.username}}</td>
                    <td>{{item.regno}}</td>
                    <td>{{item.iticode}}</td>
                    <td>{{item.ntef}}</td>
                    <td>{{item.issuedetail}}</td>
                    <td [class]="item.admin_status">{{item.admin_status}}</td>
                </tr>
            </table> -->

        </div>
    </div>
</div>